import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

/* !ALERT
  If you need to add new variables or classes please do not forget to update _brightr-button.scss file!
*/

@Directive({
  selector: '[appBrightrButton]',
  standalone: true,
})
export class BrightrButtonDirective implements OnInit, OnChanges {
  @Input() color: 'secondary' | 'primary' | 'black' | 'gray' | null = null;
  @Input() size: 'lg' | 'lg-new' | 'md' | 'sm' | 'xs' | null = null;
  @Input() iconButton: null | 'true'; // while 'true' change standard padding to make button square
  @Input() flat: null | 'true'; // while 'true' remove border and box shadow
  @Input() disabled: boolean = false;
  @Input() width: string | null; // set when you need 100% width or etc...
  @Input() loading: boolean = false;

  originalInnerText: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setStyle(this.el?.nativeElement, 'opacity', '0');
    this.renderer.addClass(this.el?.nativeElement, 'brtr-btn');
  }

  ngOnInit(): void {
    this.renderer.setProperty(
      this.el?.nativeElement,
      'disabled',
      this.disabled,
    );
    if (this.color) {
      this.renderer.addClass(this.el?.nativeElement, this.color);
    }
    if (this.disabled) {
      this.renderer.addClass(this.el?.nativeElement, `disabled`);
    }
    if (this.size) {
      this.renderer.addClass(this.el?.nativeElement, this.size);
    }

    if (this.iconButton === 'true') {
      this.renderer.addClass(this.el?.nativeElement, 'icon');
    }

    if (this.flat === 'true') {
      this.renderer.addClass(this.el?.nativeElement, 'flat');
    }
    if (this.width?.length) {
      this.renderer.setStyle(this.el?.nativeElement, 'width', this.width);
    }
    this.renderer.setStyle(this.el?.nativeElement, 'opacity', '1');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.disabled?.currentValue !== changes?.disabled?.previousValue) {
      this.renderer.setProperty(
        this.el?.nativeElement,
        'disabled',
        this.disabled,
      );
      if (this.disabled) {
        this.renderer.addClass(this.el?.nativeElement, `disabled`);
      } else {
        this.renderer.removeClass(this.el?.nativeElement, 'disabled');
      }
    }
    if (
      changes?.color?.currentValue !== changes?.color?.previousValue &&
      !changes?.color?.firstChange
    ) {
      this.renderer.removeClass(
        this.el?.nativeElement,
        changes?.color?.previousValue,
      );
      if (this.color) {
        this.renderer.addClass(this.el.nativeElement, this.color);
      }

      if (!this.color && changes?.color?.previousValue) {
        this.renderer.removeClass(this.el?.nativeElement, this.color);
      }
    }

    if (
      changes?.iconButton?.currentValue !==
        changes?.iconButton?.previousValue &&
      !changes?.iconButton?.firstChange
    ) {
      if (this.iconButton === 'true') {
        this.renderer.addClass(this.el?.nativeElement, 'icon');
      } else {
        this.renderer.removeClass(this.el?.nativeElement, 'icon');
      }
    }
    if (
      changes?.width?.currentValue !== changes?.width?.previousValue &&
      !changes?.width?.firstChange
    ) {
      if (this.width?.length) {
        this.renderer.setStyle(this.el?.nativeElement, 'width', this.width);
      } else {
        this.renderer.removeClass(this.el?.nativeElement, 'width');
      }
    }
    if (changes?.loading?.currentValue !== changes?.loading?.previousValue) {
      if (this.loading) {
        this.el.nativeElement.style.width = `${
          (this.el.nativeElement as HTMLElement).offsetWidth
        }px`;
        this.el.nativeElement.style.height = `${
          (this.el.nativeElement as HTMLElement).offsetHeight
        }px`;
        this.originalInnerText = this.el.nativeElement.innerHTML;

        this.renderer.addClass(this.el?.nativeElement, `loading`);
        this.el.nativeElement.innerHTML =
          '<span class="_loader-spinner"></span>';
      } else {
        if (this.originalInnerText) {
          this.el.nativeElement.innerHTML = this.originalInnerText;
        }
        this.renderer.removeClass(this.el?.nativeElement, 'loading');
      }
    }
  }
}
